const CLINIC_MODE_WELLNESS = 'wellness'
const CLINIC_MODE_MEDICAL_SPA = 'medical_spa'
const CLINIC_MODE_MIXED = 'mixed'

const SUBMODE_STORAGE_KEY = 'clinicSubmode'
const VALID_MODES = [CLINIC_MODE_WELLNESS, CLINIC_MODE_MEDICAL_SPA, CLINIC_MODE_MIXED]
const VALID_SUBMODES = [CLINIC_MODE_WELLNESS, CLINIC_MODE_MEDICAL_SPA]
const DEFAULT_CLINIC_MODE = CLINIC_MODE_WELLNESS
const DEFAULT_CLINIC_SUBMODE = CLINIC_MODE_WELLNESS
const runtimeClinicConfig = {
  clinicMode: null,
  defaultSubmode: null
}

const normalizeMode = (value, fallback = CLINIC_MODE_MEDICAL_SPA) => {
  const mode = String(value || '').trim().toLowerCase()
  return VALID_MODES.includes(mode) ? mode : fallback
}

const normalizeSubmode = (value, fallback = CLINIC_MODE_WELLNESS) => {
  const mode = String(value || '').trim().toLowerCase()
  return VALID_SUBMODES.includes(mode) ? mode : fallback
}

export const getClinicMode = () => {
  if (runtimeClinicConfig.clinicMode) {
    return normalizeMode(runtimeClinicConfig.clinicMode, DEFAULT_CLINIC_MODE)
  }
  return normalizeMode(process.env.REACT_APP_CLINIC_MODE, DEFAULT_CLINIC_MODE)
}

export const getDefaultSubmode = () => {
  if (runtimeClinicConfig.defaultSubmode) {
    return normalizeSubmode(runtimeClinicConfig.defaultSubmode, DEFAULT_CLINIC_SUBMODE)
  }
  return normalizeSubmode(process.env.REACT_APP_DEFAULT_SUBMODE, DEFAULT_CLINIC_SUBMODE)
}

export const applyRuntimeClinicModeConfig = (config = {}) => {
  runtimeClinicConfig.clinicMode = normalizeMode(config?.clinicMode, DEFAULT_CLINIC_MODE)
  runtimeClinicConfig.defaultSubmode = normalizeSubmode(config?.defaultSubmode, DEFAULT_CLINIC_SUBMODE)
}

export const getStoredSubmode = () => {
  if (typeof window === 'undefined') return null
  return normalizeSubmode(window.localStorage.getItem(SUBMODE_STORAGE_KEY), null)
}

export const persistSubmode = (submode) => {
  if (typeof window === 'undefined') return
  const next = normalizeSubmode(submode, getDefaultSubmode())
  window.localStorage.setItem(SUBMODE_STORAGE_KEY, next)
}

export const getEffectiveSubmode = () => {
  const clinicMode = getClinicMode()
  if (clinicMode === CLINIC_MODE_WELLNESS) return CLINIC_MODE_WELLNESS
  if (clinicMode === CLINIC_MODE_MEDICAL_SPA) return CLINIC_MODE_MEDICAL_SPA
  return getStoredSubmode() || getDefaultSubmode()
}

export const getClinicModeFlags = () => {
  const clinicMode = getClinicMode()
  const effectiveSubmode = getEffectiveSubmode()
  const isWellnessEffective = effectiveSubmode === CLINIC_MODE_WELLNESS
  const isMedicalSpaEffective = effectiveSubmode === CLINIC_MODE_MEDICAL_SPA

  return {
    clinicMode,
    effectiveSubmode,
    isMixedClinicMode: clinicMode === CLINIC_MODE_MIXED,
    isWellnessEffective,
    isMedicalSpaEffective,
    canUseAutoSort: !isMedicalSpaEffective,
    canUsePractitionerRoomSort: isWellnessEffective,
    canAccessInventory: !isWellnessEffective
  }
}

export {
  SUBMODE_STORAGE_KEY,
  CLINIC_MODE_WELLNESS,
  CLINIC_MODE_MEDICAL_SPA,
  CLINIC_MODE_MIXED
}
